import { Button } from '@themesberg/react-bootstrap';
import React from 'react'

export const AddTicketTableActionRow = (props) => {
  const { onAddSingle, onAddPair, region } = props
  const showPairButton = region !== 'MB'
  
  return (
    <tr>
      <td colSpan={5} className="text-center">
        <Button variant='info' onClick={onAddSingle} className={showPairButton ? "me-2" : ""}>
          Thêm vé đơn
        </Button>
        {showPairButton && (
          <Button variant='success' onClick={onAddPair}>
            Thêm cặp nguyên
          </Button>
        )}
      </td>
    </tr>
  );
};